import React, { useEffect, useState } from "react";
import { TouchableOpacity, Platform } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { createTest } from "@/components/http/events";
import { useAuth } from "@/components/AuthContext";
import { Ionicons } from "@expo/vector-icons";
import Text from "@/components/shared/AppText";
import { openStreamWindow } from "@/components/Utils";
import { hasDesktopStudio } from "@/components/desktop/desktopApp";
import tw from "twrnc";
import { t } from "@/localization";

const NewTestButton = ({
  style,
  relatedEvent,
  title,
  forceNew = true,
  openStreamDirectly = false,
}) => {
  const navigation = useNavigation();
  const { prefer_multiple_tests, broadcaster, profileLoaded } = useAuth();
  const [testEvent, setTestEvent] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const buttonTitle = title || t("Start free test");

  useEffect(() => {
    (async () => {
      if (broadcaster && profileLoaded) {
        const e = await createTest(broadcaster, false);
        setTestEvent(e);
      }
    })();
  }, [broadcaster, profileLoaded]);

  const onTestButtonPress = async () => {
    setIsButtonDisabled(true);
    try {
      let eventToUse = testEvent;

      if (profileLoaded && prefer_multiple_tests && forceNew) {
        // Create a new test
        eventToUse = await createTest(broadcaster, true);
      } else if (!testEvent) {
        // If no test event exists, create one
        eventToUse = await createTest(broadcaster, false);
      }

      if (openStreamDirectly && (Platform.OS !== "web" || hasDesktopStudio())) {
        // Open stream window directly for native platforms and the Studio of
        // EventLive for Mac or Windows
        await openStreamWindow(eventToUse);
      } else {
        // Navigate to HowToStream screen
        navigation.navigate("HowToStream", {
          relatedEvent,
          event: eventToUse,
          slug: eventToUse.slug,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsButtonDisabled(false);
    }
  };

  return (
    <TouchableOpacity
      style={[
        tw`flex-row items-center justify-center rounded-lg bg-[#3f5b7a] px-4 py-3 min-h-[48px]`,
        style,
        isButtonDisabled && tw`opacity-50`,
      ]}
      onPress={onTestButtonPress}
      disabled={isButtonDisabled}
    >
      <Ionicons name="videocam-outline" size={24} color="#fff" />
      <Text style={tw`ml-2.5 text-base text-white font-medium`}>
        {buttonTitle}
      </Text>
    </TouchableOpacity>
  );
};

export default NewTestButton;
